import { ToastContainer } from "react-toastify";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import { useEffect, useState } from "react";
export default function MobileNotification() {
  const [SideOpener, setSideOpner] = useState(false);
  // const dispatch = useDispatch();
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection
            Page="Notification"
            OpenSideMenu={OpenSideMenu}
          />
          <div className="Mobile_Support">
            {/* {!batchDet && !DemoClasses?.length ? (
              <div style={{ padding: "20px" }}>
                <Lock />
              </div>
            ) : ( */}
            <div className="container Notify_m_view">
              {/* <div className={Styles.no_notification_box}>
                <img
                  src="/assets/image/No-Notification.png"
                  alt="No Notification Icon"
                  style={{ marginRight: "20px" }}
                />
                <div className={Styles.no_notification_text}>
                  You have no notifications right now.
                </div>
              </div> */}

              <div class="notification-panel">
                <div class="panel-header">
                  <h2>Notifications</h2>
                  <button class="clear-btn" onclick="clearAll()">
                    Clear All
                  </button>
                </div>

                <div class="notification">
                  <div class="notification-icon">🔔</div>
                  <div class="notification-content">
                    <p class="notification-title">Order Update</p>
                    <p class="notification-desc">
                      Your order #1234 has been shipped.
                    </p>
                  </div>
                  <button
                    class="close-btn"
                    onclick="this.parentElement.remove()"
                  >
                    ×
                  </button>
                </div>

                <div class="notification">
                  <div class="notification-icon">🎉</div>
                  <div class="notification-content">
                    <p class="notification-title">Congratulations</p>
                    <p class="notification-desc">
                      You’ve earned 100 reward points!
                    </p>
                  </div>
                  <button
                    class="close-btn"
                    onclick="this.parentElement.remove()"
                  >
                    ×
                  </button>
                </div>

                <div class="notification">
                  <div class="notification-icon">⚠️</div>
                  <div class="notification-content">
                    <p class="notification-title">Security Alert</p>
                    <p class="notification-desc">
                      Login attempt from new device detected.
                    </p>
                  </div>
                  <button
                    class="close-btn"
                    onclick="this.parentElement.remove()"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>
            {/* )} */}
          </div>
          <MobileBottomMenu Page="Notifications" />
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
